import React, { useState } from 'react';
import './tabs.scss';
import PropTypes from 'prop-types';
import k10 from '../../assets/images/10k.png';
import k20 from '../../assets/images/20k.png';
import k30 from '../../assets/images/30k.png';
import k40 from '../../assets/images/40k.png';
import k50 from '../../assets/images/50k.png';
import k60 from '../../assets/images/60k.png';

import finishicon from '../../assets/images/finishicon.svg';
import finishiconselected from '../../assets/images/finishicon-selected.svg';

const Tabs = ({ tabs, onChange }) => {
  const [selected, setSelected] = useState(0);

  const tabIcon = (tab, selected) => {
    let selectedIcon = '';
    switch (tab) {
      case '10K': {
        selectedIcon = selected ? k10 : k10;
        break;
      }
      case '20K': {
        selectedIcon = selected ? k20 : k20;
        break;
      }
      case '30K': {
        selectedIcon = selected ? k30 : k30;
        break;
      }
      case '40K': {
        selectedIcon = selected ? k40 : k40;
        break;
      }
      case '50K': {
        selectedIcon = selected ? k50 : k50;
        break;
      }
      case '60K': {
        selectedIcon = selected ? k60 : k60;
        break;
      }

      default: {
        selectedIcon = selected ? finishiconselected : finishicon;
        break;
      }
    }
    return selectedIcon;
  };

  return (
    <div className='tabs'>
      {tabs.map((tab, index) => {
        return (
          <div
            key={tab}
            className={`tab${index === selected ? ' selected' : ''}`}
            onClick={() => {
              setSelected(index);
              onChange(index);
            }}
          >
            <img src={tabIcon(tab, index === selected)} alt={tab}></img>{' '}
          </div>
        );
      })}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Tabs;
